import React from 'react';

export type GlyphIconId =
  | 'headset'
  | 'award'
  | 'lock'
  | 'support'
  | 'shield'
  | 'star'
  | 'check'
  | 'globe'
  | 'heart'
  | 'clock'
  | 'none';

const iconProps = {
  width: '100%',
  height: '100%',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.9,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

// Paths mirror prototipo_carga_header_v18.html `benefitIcons` exactly.
const HeadsetIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <path d='M4 13v-1a8 8 0 0 1 16 0v1' />
    <path d='M4 13h3v7H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 1-2Z' />
    <path d='M20 13h-3v7h2a2 2 0 0 0 2-2v-3a2 2 0 0 0-1-2Z' />
    <path d='M17 20c0 1.1-.9 2-2 2h-3' />
  </svg>
);

const AwardIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <circle cx='12' cy='9' r='6' />
    <path d='m8.5 14-1.5 8 5-3 5 3-1.5-8' />
    <path d='m12 6 1 2 2 .3-1.5 1.5.4 2.2-1.9-1-1.9 1 .4-2.2L9 8.3 11 8Z' />
  </svg>
);

const LockIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <rect height='11' rx='2' width='16' x='4' y='10' />
    <path d='M8 10V7a4 4 0 0 1 8 0v3' />
    <path d='M12 14v3' />
  </svg>
);

const SupportIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <path d='M4 12a8 8 0 1 1 2.3 5.7' />
    <path d='M4 16v4h4' />
    <text
      x='12'
      y='14'
      textAnchor='middle'
      fontSize='6.5'
      fontFamily='Arial'
      fontWeight={700}
      fill='currentColor'
      stroke='none'
    >
      24/7
    </text>
  </svg>
);

const ShieldIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <path d='M12 3 4.5 6v5.5c0 4.8 3.2 8 7.5 9.5 4.3-1.5 7.5-4.7 7.5-9.5V6Z' />
    <path d='m9 12 2 2 4-4' />
  </svg>
);

const StarIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <path d='m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9Z' />
  </svg>
);

const CheckIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <circle cx='12' cy='12' r='9' />
    <path d='m8 12 2.5 2.5L16 9' />
  </svg>
);

const GlobeIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <circle cx='12' cy='12' r='9' />
    <path d='M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18' />
  </svg>
);

const HeartIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <path d='M20.8 5.8a5.5 5.5 0 0 0-7.8 0L12 6.8l-1-1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-8.4a5.5 5.5 0 0 0 0-7.8Z' />
  </svg>
);

const ClockIcon: React.FC = () => (
  <svg {...iconProps} aria-hidden='true'>
    <circle cx='12' cy='12' r='9' />
    <path d='M12 7v5l3 2' />
  </svg>
);

const NoIcon: React.FC = () => null;

export const GLYPH_ICONS: Record<GlyphIconId, React.FC> = {
  headset: HeadsetIcon,
  award: AwardIcon,
  lock: LockIcon,
  support: SupportIcon,
  shield: ShieldIcon,
  star: StarIcon,
  check: CheckIcon,
  globe: GlobeIcon,
  heart: HeartIcon,
  clock: ClockIcon,
  none: NoIcon,
};

export const GLYPH_ICON_OPTIONS: { value: GlyphIconId; label: string }[] = [
  { value: 'headset', label: 'Auriculares' },
  { value: 'award', label: 'Medalla' },
  { value: 'lock', label: 'Candado' },
  { value: 'support', label: 'Soporte 24/7' },
  { value: 'shield', label: 'Escudo' },
  { value: 'star', label: 'Estrella' },
  { value: 'check', label: 'Verificación' },
  { value: 'globe', label: 'Mundo' },
  { value: 'heart', label: 'Corazón' },
  { value: 'clock', label: 'Reloj' },
  { value: 'none', label: 'Sin icono' },
];
